// extracted by mini-css-extract-plugin
export default {"item":"Item-module--item--3WtY_","content":"Item-module--content--3cfg1","imageWrapper":"Item-module--imageWrapper--mHbAj","image":"Item-module--image--Tjb_s"};